import React from 'react';
import { Toolbar } from 'react-big-calendar';
import moment from 'moment';

const AttendanceToolbar = (toolbar) => {
  const goToBack = () => {
    toolbar.onNavigate('PREV');
  };

  const goToNext = () => {
    toolbar.onNavigate('NEXT');
  };

  const goToCurrent = () => {
    toolbar.onNavigate('TODAY');
  };

  // Check if current view date is before today (or current week)
  // Show Next button only when viewing past dates
  const isViewingPastDate = toolbar.date && moment(toolbar.date).isBefore(moment(), 'month');

  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        <button type="button" onClick={goToBack}>Back</button>
        {isViewingPastDate && (
          <button type="button" onClick={goToNext}>Next</button>
        )}
        <button type="button" onClick={goToCurrent}>Today</button>
      </span>
      <span className="rbc-toolbar-label">{toolbar.label}</span>
    </div>
  );
};

export default AttendanceToolbar;
